// extracted by mini-css-extract-plugin
export var background = "dC_y";
export var close = "dC_km";
export var content = "dC_cs";
export var frame = "dC_kh";
export var menuBackground = "dC_kk";
export var menuContent = "dC_kl";
export var open = "dC_kj";